/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'ngx-app',
  template: `<router-outlet></router-outlet><toaster-container></toaster-container>`,
})

export class AppComponent {
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts